import { useContext } from "react";
import { Typography, Stack, Autocomplete, TextField } from "@mui/material";
import { AppContext } from "../App";
import { LANGUAGES } from "../constants/values";

export function ProviderLanguage() {
  const { form, updateForm } = useContext(AppContext);

  const handleSubmit = (_event: React.SyntheticEvent, value: string | null) => {
    updateForm({ providerLanguage: value || undefined });
  };

  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        padding: { xs: "1rem", sm: "2rem" },
      }}
    >
      <Typography variant="h6" gutterBottom>
        My provider should speak the following language:
      </Typography>

      <Autocomplete
        value={form.providerLanguage || ""}
        options={LANGUAGES}
        fullWidth
        disablePortal
        freeSolo={false} // Prevents free text input
        noOptionsText="Please select from the list"
        onChange={handleSubmit}
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", sm: "450px", md: "500px" },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Please select language"
            variant="outlined"
          />
        )}
      />
    </Stack>
  );
}
